module.exports = __webpack_public_path__ + "static/media/hello-peter.d4ec3d0d.svg";